import { put } from 'redux-saga/effects';

import changeLocation from './changeLocation';

export default function* sagaLocationChange(action: any) {
  yield put(changeLocation(action.payload));
}
